// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__13Rn9","title":"Info_title__2Wxzc","selects":"Info_selects__1zg6p","requiredAsterisk":"Info_requiredAsterisk__1Y_Wj"};